import React from 'react';
import { ExtendedRefs, Placement, useInteractions } from '@floating-ui/react';

export interface AnchoredModalProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  children: ((props: { onClose: () => void }) => React.ReactNode) | React.ReactNode;
  renderTrigger: (
    ref: ExtendedRefs<HTMLElement>['setReference'],
    props: ReturnType<typeof useInteractions>['getReferenceProps'],
  ) => React.ReactNode;
  placement?: Placement;
  offset?: number;
  showArrow?: boolean;
  arrowSize?: number;
  closeOnEscape?: boolean;
  closeOnOutsideClick?: boolean;
  closeOnContentClick?: boolean;
  returnFocus?: boolean;
  radius?: AnchoredModalRadius;
  /** Controlled mode: external open state */
  isOpen?: boolean;
  /** Controlled mode: callback when open state should change */
  onOpenChange?: (open: boolean) => void;
  /** @deprecated Use onOpenChange instead for controlled mode */
  onOpen?: () => void;
  /** @deprecated Use onOpenChange instead for controlled mode */
  onClose?: () => void;
  /** ID of the element that labels the modal for screen readers */
  'aria-labelledby'?: string;
  /** ID of the element that describes the modal content for screen readers */
  'aria-describedby'?: string;
}

export type AnchoredModalRadius = 'none' | 'sm' | 'md' | 'lg' | 'xl';

export const anchoredModalRadiusClassNameMapping: Record<AnchoredModalRadius, string> = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
};
